import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AnalyticsDashboard\GetAnalyticsDataController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/GetAnalyticsDataController.php
* @route '/api/analytics/analytics-data'
*/
const GetAnalyticsDataController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetAnalyticsDataController.url(options),
    method: 'post',
})

GetAnalyticsDataController.definition = {
    methods: ["post"],
    url: '/api/analytics/analytics-data',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AnalyticsDashboard\GetAnalyticsDataController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/GetAnalyticsDataController.php
* @route '/api/analytics/analytics-data'
*/
GetAnalyticsDataController.url = (options?: RouteQueryOptions) => {
    return GetAnalyticsDataController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AnalyticsDashboard\GetAnalyticsDataController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/GetAnalyticsDataController.php
* @route '/api/analytics/analytics-data'
*/
GetAnalyticsDataController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetAnalyticsDataController.url(options),
    method: 'post',
})

export default GetAnalyticsDataController